import React from 'react';
import { Button, Fab, useMediaQuery, useTheme } from '@mui/material';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import { Link as RouterLink, useLocation } from 'react-router-dom';

const HowToGuideButton = () => {
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  if (location.pathname === '/how-to-use') return null;

  const baseSx = {
    position: 'fixed',
    right: 16,
    bottom: 'calc(var(--tape-h, 48px) + env(safe-area-inset-bottom, 0px) + 16px)',
    zIndex: (muiTheme) => muiTheme.zIndex.tooltip + 1,
    boxShadow: '0 12px 24px rgba(15,23,42,0.25)',
  };

  if (isMobile) {
    return (
      <Fab
        component={RouterLink}
        to="/how-to-use"
        color="primary"
        size="medium"
        aria-label="How-To Guide"
        sx={baseSx}
      >
        <MenuBookOutlinedIcon />
      </Fab>
    );
  }

  return (
    <Button
      component={RouterLink}
      to="/how-to-use"
      startIcon={<MenuBookOutlinedIcon />}
      variant="contained"
      color="primary"
      sx={{
        ...baseSx,
        borderRadius: 999,
        textTransform: 'none',
        fontWeight: 600,
      }}
    >
      How-To Guide
    </Button>
  );
};

export default HowToGuideButton;
